import { api } from "@/lib/api/client";

export type DataSourceKind = "sqlserver" | "postgres" | "mysql" | "oracle" | "csv_drop";

export interface DataSource {
  id: string;
  name: string;
  kind: DataSourceKind;
  family: string;
  host: string | null;
  port: number | null;
  database: string | null;
  username: string | null;
  connection_extras: Record<string, unknown>;
  enabled: boolean;
  read_only: boolean;
  last_health_check: string | null;
  last_health_message: string | null;
  created_at: string;
  updated_at: string;
}

export function listDataSources() {
  return api.get<DataSource[]>("/data-sources");
}

export function ingestDataSource(id: string) {
  return api.post<unknown>(`/data-sources/${id}/ingest`, {});
}

export function getDataSource(id: string) {
  return api.get<DataSource>(`/data-sources/${id}`);
}

export interface CreateDataSourceInput {
  name: string;
  kind: DataSourceKind;
  family: string;
  host?: string | null;
  port?: number | null;
  database?: string | null;
  username?: string | null;
  password?: string | null;
  connection_extras?: Record<string, unknown>;
  enabled?: boolean;
  read_only?: boolean;
}

export function createDataSource(payload: CreateDataSourceInput) {
  return api.post<DataSource>("/data-sources", payload);
}
